module.exports = __webpack_public_path__ + "img/cash.43ae850a.svg";